module.exports = __webpack_public_path__ + "img/man-in-boat.0204b7f.svg";